// staticMap turns any [data-static-map] box into a read-only Leaflet map with a
// pin on it — used to show the manufacturer where the job actually is.
//
// Read-only on purpose: this is somebody else's location. There is nothing to
// drag, and the map should not swallow the page scroll while they read the lead.
import L from "leaflet";

export function mountStaticMaps(root: ParentNode = document): void {
  for (const box of root.querySelectorAll<HTMLElement>("[data-static-map]")) {
    if (box.dataset["mapReady"] === "1") continue; // survives HTMX swaps
    const lat = Number(box.dataset["lat"]);
    const lng = Number(box.dataset["lng"]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;

    box.dataset["mapReady"] = "1";

    const map = L.map(box, {
      center: [lat, lng],
      zoom: 15,
      scrollWheelZoom: false,
      dragging: false,
      zoomControl: false,
      doubleClickZoom: false,
      boxZoom: false,
      keyboard: false,
      attributionControl: true,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "&copy; OpenStreetMap",
    }).addTo(map);

    L.marker([lat, lng], {
      icon: L.divIcon({
        className: "map-pin",
        html: "<span class=\"map-pin__dot\"></span>",
        iconSize: [24, 24],
        iconAnchor: [12, 12],
      }),
      interactive: false,
    }).addTo(map);

    // Leaflet measures its container once; inside a panel that is still laying
    // out, that measurement is wrong and the map renders torn.
    new ResizeObserver((): void => {
      map.invalidateSize();
    }).observe(box);
  }
}
